import { render, staticRenderFns } from "./form-label.vue?vue&type=template&id=44387f37"
import script from "./form-label.vue?vue&type=script&lang=js"
export * from "./form-label.vue?vue&type=script&lang=js"
import style0 from "./form-label.vue?vue&type=style&index=0&id=44387f37&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports